export const state = {
  moyenRechercherEmploi: undefined,
  moyenRechercherEmplois: [],
  sousMoyenRechercherEmploi: undefined,
  sousMoyenRechercherEmplois: []
}